<template>
  <div style="width: 100%; height: 100%; position: relative;">
    <pui-common-spinner
      ref="masonrySpinner"
      v-if="isLoading"
      :size="20"
      :strokeWidth="2"
      :hideMessage="true"
      position="fixed"
      class="brightcove-spinner"
    />
    <div v-else-if="!hasError && !isLoading" style="width: 100%; height: 100%">
      <object :data="pdfMediaUrl" style="width: 100%; height: 100%" type="application/pdf">
      </object>
    </div>
    <div v-else style="width: 100%; height: 100%;">
      <default-viewer :file="file" :getMediaUrl="getMediaUrl" :objectFit="'contain'" />
    </div>
  </div>
</template>

<script>
import DefaultViewer from './DefaultViewer';

export default {
  name: 'pui-dam-pdf-viewer',
  components: { DefaultViewer },
  props: {
    file: {
      type: Object,
      required: true,
    },
    getMedia: {
      type: Function,
      required: true,
    },
    getMediaUrl: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      pdfMediaUrl: '',
      hasError: false,
      isLoading: false,
    };
  },
  watch: {
    /**
     * Watches the current file to change the displayed pdf to be
     * the one of the current file
     */
    file(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.pdfMediaUrl) {
          URL.revokeObjectURL(this.pdfUrl);
        }
        this.fetchPdf();
      }
    },
  },
  methods: {
    /**
     * Fetches the current pdfMediaUrl
     */
    async fetchPdf() {
      this.isLoading = true;
      this.hasError = false;
      this.pdfMediaUrl = '';

      try {
        const url = await this.getMedia('application/pdf');
        if (url) {
          this.pdfMediaUrl = url;
        } else {
          throw new Error('received no data from getMedia or wrong type');
        }
      } catch (error) {
        this.hasError = true;
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.fetchPdf();
  },
};
</script>
